export const PayoutAccountStatus = {
  NotStarted: 'not_started',
  Incomplete: 'incomplete',
  PendingVerification: 'pending_verification',
  Active: 'active',
  ActionRequired: 'action_required',
  Restricted: 'restricted',
} as const

export type PayoutAccountStatus = (typeof PayoutAccountStatus)[keyof typeof PayoutAccountStatus]

export const PayoutLinkPurpose = {
  Onboarding: 'onboarding',
  Update: 'update',
} as const

export type PayoutLinkPurpose = (typeof PayoutLinkPurpose)[keyof typeof PayoutLinkPurpose]

export const PayoutStatus = {
  Pending: 'pending',
  InTransit: 'in_transit',
  Paid: 'paid',
  Failed: 'failed',
  Canceled: 'canceled',
} as const

export type PayoutStatus = (typeof PayoutStatus)[keyof typeof PayoutStatus]

export interface PayoutAccount {
  status: PayoutAccountStatus
  accepts_payments: boolean
  requires_action: boolean
  // null = unknown (never synced)
  payouts_enabled: boolean | null
  requirements_due_at: string | null
  status_synced_at: string | null
}

export interface PayoutHostedLink {
  url: string
  expires_at: string
}

export interface PayoutBalanceAmount {
  currency: string
  // Decimal string, e.g. "120.50"
  amount: string
}

export interface PayoutBalance {
  available: PayoutBalanceAmount[]
  pending: PayoutBalanceAmount[]
}

export interface NextPayout {
  amount: string
  currency: string
  // Y-m-d
  expected_on: string
  is_estimate: boolean
}

export interface PayoutRecord {
  amount: string
  currency: string
  status: PayoutStatus
  // Y-m-d (UTC)
  arrival_date: string
  created_at: string
  bank_account_last4: string | null
}

export interface PayoutSummary {
  account: PayoutAccount
  balance: PayoutBalance | null
  next_payout: NextPayout | null
  payouts: PayoutRecord[]
  retrieved_at: string
}

export interface PayoutNotReadyError {
  error: 'payout_account_not_ready'
  message: string
  payout_account_status: PayoutAccountStatus
}
